// 用户接口
export interface User {
  id: string;
  name: string;
  phone_number: string;
  create_time: string;
  doctor?: Doctor | null;
  patient?: Patient | null;
}

// 医生接口
export interface Doctor {
  id: string;
  user_id: string;
  title: string;
  create_time: string;
  user?: User | null;
  patients?: Patient[];
}

// 患者接口
export interface Patient {
  id: string;
  user_id: string;
  gender: string;
  birth_date: string | null;
  create_time: string;
  user?: User | null;
}

// 治疗记录额外值接口
export interface ExtraValue {
  type: string;                 // 类型，可选值：enum, field
  enum_type_id?: string;         // 枚举类型ID，字符串化的64位整型
  selected_enum_value_id?: string; // 选中的枚举值ID（单选），可选字段
  selected_enum_value_ids?: string[]; // 选中的枚举值ID列表（多选），可选字段
  field_id?: string;             // 自定义字段ID，字符串化的64位整型
  field_value?: string;          // 自定义字段值
}

// 治疗记录接口
export interface TreatmentRecord {
  id: string;
  patient_id: string;
  doctor_id: string;
  treatment_date: string;
  content: string;
  extra?: ExtraValue[];         // 额外信息，存储自定义枚举和自定义字段值
  is_deleted: number;
  create_time: string;
  patient: Patient;
  doctor: Doctor;
  comments: TreatmentRecordComment[];
}

// 治疗记录评论接口
export interface TreatmentRecordComment {
  id: string;
  record_id: string;
  user_id: string;
  content: string;
  creator_name: string;
  comment_date: string;
  create_time: string;
  record: TreatmentRecord;
  user: User;
}



// 预约状态枚举
export enum AppointmentStatus {
  Pending = 0,
  Confirmed = 1,
  Cancelled = 2,
  Rejected = 3
}

// 医生排班模板接口
export interface DoctorScheduleTemplate {
  id: string;
  doctor_id: string;
  schedule_location_id: string | null;
  slot_name: string;
  weekday: number;
  start_time: string;
  end_time: string;
  capacity: number;
  create_time: string;
  update_time: string;
  schedule_location?: ScheduleLocation;
}

// 医生排班接口
export interface DoctorSchedule {
  id: string;
  doctor_id: string;
  schedule_location_id: string | null;
  schedule_name: string;
  start_time: string;
  end_time: string;
  doctor_schedule_template_id: string;
  capacity_initial: number;
  capacity_left: number;
  create_time: string;
  schedule_location?: ScheduleLocation;
}

// 预约接口
export interface Appointment {
  id: string;
  patient_id: string;
  doctor_id: string;
  doctor_schedule_id: string;
  schedule_location_id: string | null;
  start_time: string;
  end_time: string;
  description: string;
  status: AppointmentStatus;
  create_time: string;
  update_time: string;
  patient: Patient;
  doctor: Doctor;
  doctor_schedule: DoctorSchedule;
  schedule_location?: ScheduleLocation;
}

// 日程地点接口
export interface ScheduleLocation {
  id: string;
  name: string;
  address: string;
  guide_info: string;
  doctor_id: string;
  create_time: string;
  update_time: string;
}

// 自定义枚举类型接口
export interface CustomEnumType {
  visible_to_customer: any;
  id: string;
  doctor_id?: string | null;
  is_global: boolean;
  name: string;
  scenario: CustomParamScenario;
  mode: CustomEnumMode;
  order: number;
  extra?: Record<string, any>;
  is_enabled: boolean;
  create_time: string;
  update_time: string;
}

// 自定义枚举值接口
export interface CustomEnumValue {
  id: string;
  type_id: string;
  name: string;
  description: string;
  order: number;
  extra?: Record<string, any>;
  is_enabled: boolean;
  create_time: string;
  update_time: string;
}

// 自定义枚举类型场景枚举
export enum CustomParamScenario {
  Treatment = 'treatment',
  Appointment = 'appointment',
  PatientProfile = 'patient_profile'
}

// 自定义枚举类型模式枚举
export enum CustomEnumMode {
  Single = 'single',
  Multiple = 'multiple'
}

// 自定义字段接口
export interface CustomField {
  id: string;
  doctor_id?: string | null;
  is_global: boolean;
  name: string;
  hint: string;
  scenario: CustomParamScenario;
  order: number;
  extra?: Record<string, any>;
  is_enabled: boolean;
  visible_to_customer: boolean;
  is_multiline: boolean;
  is_deleted: boolean;
  create_time: string;
  update_time: string;
}